
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/login",
      function () {
        return require("private-next-pages/en/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/login"])
      });
    }
  